<script>
    import "./dropdown.css";
    export let options = [];
    export let value = options[0] || {};
    export let onValueChange;
    let open = false;
    const toggle = () => {
        open = !open;
    }
    const onChange = (item) => {
        onValueChange(item);
        open = false;
    }
</script>

<div class="dropdown-wrapper">
    <button class="dropdown-display-wrapper flex justify-between items-center" on:click={toggle}>
        <span>{value?.label || value}</span>
        <svg class="ml-auto" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23834 6.42703C5.36219 6.41592 5.4796 6.35286 5.57161 6.248L10.016 1.21824L10.016 1.21834C10.1256 1.09437 10.1916 0.920796 10.1994 0.735823C10.2072 0.55075 10.1562 0.369294 10.0577 0.231475C9.95915 0.0936705 9.82111 0.0107321 9.67393 0.000986907C9.52675 -0.00885629 9.38251 0.0552716 9.27293 0.179139L5.2002 4.78975L1.12746 0.179139C1.01787 0.0552717 0.873558 -0.00885793 0.726459 0.000987014C0.579279 0.0107327 0.441246 0.0936681 0.342657 0.231475C0.244151 0.369279 0.193151 0.55075 0.20098 0.735823C0.208809 0.920798 0.274766 1.09437 0.384355 1.21834L4.82871 6.24809L4.82871 6.248C4.94039 6.37508 5.08819 6.4396 5.23846 6.42703L5.23834 6.42703Z" fill="white"/>
        </svg>
    </button>
    <div class="dropdown-container" class:open={open}>
        <div class="dropdown-content flex column-direction">
            {#each options as item}
                <div class="dropdown-item-wrapper" on:click={toggle} on:click={() => onChange(item.value || item)}>
                    {item.label || item}
                </div>
            {/each}
        </div>
        <div class="dropdown-overlay" class:open={open} on:click={() => {open = false}} />
    </div>
</div>
